import React from "react";
import CartPage from "./Pages/CartPage";
import Header from "./Components/Layout/Header";
import { Route, Routes } from "react-router-dom";
import HomePage from "./Pages/HomePage.jsx";
import CategoryPage from "./Pages/CategoryPage.jsx";
import ProductPage from "./Pages/ProductPage.jsx";
import LoginAndSigup from "./Components/Layout/LoginAndSigup.jsx";
import SearchPage from "./Pages/SearchPage.jsx";
import AdminDashboard from "./Pages/Admin/AdminDashboard.jsx";
import UsersPage from "./Pages/Admin/UsersPage.jsx";
import ProductsPage from "./Pages/Admin/ProductsPage.jsx";
import OrdersPage from "./Pages/Admin/OrdersPage.jsx";
import AddProductPage from "./Pages/Admin/AddProductPage";
import EditProductPage from "./Pages/Admin/EditProductPage";
import AdminRoute from "./Components/Layout/AdminRoute.jsx";
import Account from "./Pages/Account.jsx";

export default function App() {
  return (
    <div>
      <Header />
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/category/:categoryName" element={<CategoryPage />} />
        <Route path="/product/:id" element={<ProductPage />} />
        <Route path="/cart" element={<CartPage />} />
        <Route path="/signinandsignup" element={<LoginAndSigup />} />
        <Route path="/search/:keyword" element={<SearchPage />} />
        <Route path="/account" element={<Account />} />
        <Route
          path="/admin"
          element={
            <AdminRoute>
              <AdminDashboard />
            </AdminRoute>
          }
        >
          <Route path="users" element={<UsersPage />} />
          <Route path="products" element={<ProductsPage />} />
          <Route path="products/add" element={<AddProductPage />} />
          <Route path="products/edit/:id" element={<EditProductPage />} />
          <Route path="orders" element={<OrdersPage />} />
        </Route>
      </Routes>
    </div>
  );
}
